<template>
  <div
    class="w-full h-full flex flex-col relative animate-fade-in"
    :class="theme.text"
  >
    <div class="shrink-0 h-12 flex items-center justify-between px-4 z-10">
      <button @click="$emit('back')">
        <icon-base
          name="ChevronLeft"
          class="w-6 h-6 opacity-60 hover:opacity-100"
        ></icon-base>
      </button>
      <span class="font-bold">{{ t.sync_title }}</span>
      <div class="w-6"></div>
    </div>
    <div class="flex-1 px-6 py-6">
      <div
        class="p-6 rounded-3xl mb-6 text-center"
        :class="theme.isDark ? 'bg-white/5' : 'bg-black/5'"
      >
        <div
          class="w-16 h-16 rounded-full bg-blue-500/10 flex items-center justify-center mx-auto mb-4"
        >
          <icon-base name="Cloud" class="w-8 h-8 text-blue-500"></icon-base>
        </div>
        <div class="text-2xl font-bold mb-1">{{ t.sync_cloud_data }}</div>
        <div class="text-sm opacity-50">
          {{ t.sync_last_time }}: {{ lastSync }}
        </div>
        <div class="mt-4 flex justify-center gap-4 text-xs opacity-60">
          <div>245 {{ t.sync_records }}</div>
          <div>•</div>
          <div>1.2 MB</div>
        </div>
      </div>
      <div class="space-y-4">
        <div
          class="flex items-center justify-between p-4 rounded-2xl"
          :class="
            theme.isDark ? 'bg-white/5' : 'bg-white border border-black/5'
          "
        >
          <div>
            <div class="font-bold mb-0.5">{{ t.sync_auto }}</div>
            <div class="text-xs opacity-50">实时备份数据至云端</div>
          </div>
          <button
            @click="autoSync = !autoSync"
            class="w-12 h-7 rounded-full p-1 transition-colors duration-300"
            :class="autoSync ? 'bg-emerald-500' : 'bg-gray-300'"
          >
            <div
              class="w-5 h-5 bg-white rounded-full shadow-sm transform transition-transform duration-300"
              :class="autoSync ? 'translate-x-5' : 'translate-x-0'"
            ></div>
          </button>
        </div>
      </div>
    </div>
    <div class="p-6">
      <button
        @click="handleSync"
        :disabled="syncing"
        class="w-full py-4 rounded-2xl font-bold text-lg shadow-lg flex items-center justify-center gap-2 active:scale-95 transition-all"
        :class="theme.isDark ? 'bg-white text-black' : 'bg-black text-white'"
      >
        <icon-base
          v-if="syncing"
          name="Refresh"
          class="w-5 h-5 animate-spin"
        ></icon-base
        >{{ syncing ? "Syncing..." : t.sync_now }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme", "t", "isPro"],
  data() {
    return {
      autoSync: this.isPro,
      syncing: false,
      lastSync: new Date().toLocaleTimeString(),
    };
  },
  methods: {
    handleSync() {
      this.syncing = true;
      setTimeout(() => {
        this.syncing = false;
        this.lastSync = new Date().toLocaleTimeString();
      }, 1500);
    },
  },
};
</script>
